if (!customElements.get('swym-wishlist-page')) {
    class SwymWishlistPage extends HTMLElement {
        constructor() {
            super();
            this._initializeSwymComponent();
            this.wishlistProducts = [];
        }

        _init(swat) {
            this._initializeSelectors(swat);
            window.isShareWishlistPage ? this._renderShareWishlist(swat) : this._renderWishlist(swat);
            this._attachEventListeners();
        }

        /* General funcions */

        _initializeSwymComponent() {
            if (!window.SwymCallbacks) window.SwymCallbacks = [];
            window.SwymCallbacks.push(this._init.bind(this));
        }

        _initializeSelectors(swat) {
            this.swat = swat;
            this.body = document.body;
            this.settings = JSON.parse(this.dataset.settings);
            this.sectionId = this.dataset.sectionId;
            this.isShareWishlistPage = window.isShareListPage;

            /* Page Header Selectors */

            this.accountButton = this.querySelector('#swymcs-user-login-status-btn');
            this.accountButtonText = this.accountButton.querySelector('.swymcs-user-text.swym-value');
            this.accountPopup = this.querySelector('#swymcs-user-login-status-popup');
            this.accountPopupTitleText = this.accountPopup.querySelector('#swymcs-account-popup-title');
            this.accountPopupContentText1 = this.accountPopup.querySelector('#swymcs-account-info-1');
            this.accountPopupContentText2 = this.accountPopup.querySelector('#swymcs-account-info-2');
            this.accountPopupCloseButton = this.querySelector('#swymcs-close-account-popup');
            this.accountPopupCancelButton = this.querySelector('#swymcs-cancel-account-popup');
            this.accountPopupActionButton = this.querySelector('#swymcs-account-login-action-button');
            this.additionalOptionsMenuContainer = this.querySelector('#swymcs-addtional-options-menu-container');

            this.shareListAccountPopup = this.querySelector('#swymcs-share-list-login-status-popup');
            this.shareListAccountPopupTitleText = this.querySelector('#swymcs-share-list-account-popup-title');
            this.shareListAccountPopupContentText1 = this.querySelector('#swymcs-share-list-account-info-1');
            this.shareListAccountPopupContentText2 = this.querySelector('#swymcs-share-list-account-info-2');
            this.shareListAccountPopupCloseButton = this.querySelector('#swymcs-close-share-list-account-popup');
            this.shareListAccountPopupCancelButton = this.querySelector('#swymcs-cancel-share-list-account-popup');
            this.shareListAccountPopupActionButton = this.querySelector('#swymcs-share-list-account-login-action-button');

            /* Wishlist grid container */

            this.singleWishlistTitleText = this.querySelector('#swymcs-single-wishlist-container');
            this.emptyListContainer = this.querySelector('#swym-empty-wishlist-container');
            this.wishlistContainer = this.querySelector('#swymcs-wishlist-container');
            this.listsContainer = this.querySelector('#swymcs-lists-grid');
            this.listProductsContainer = this.querySelector('#swymcs-products-grid-container');
            this.productsContainer = this.querySelector('#swymcs-products-grid');
            this.wishlistHeader = this.querySelector('#swymcs-wishlist-header');

            /* Additional Options selectors */

            this.additionalOptionsContainer = this.querySelector('#swymcs-additional-options');
            this.additionalOptionsBtn = this.querySelector('#swymcs-view-additional-options');
            this.shareListButton = this.querySelector('#swymcs-share-list');
            this.deleteListButton = this.querySelector('#swymcs-delete-list');
            this.deleteListButtonText = this.deleteListButton.querySelector('.swymcs-share-button-text');
            this.shoppingCurrencySymbol = this.querySelector('#swym-currency-symbol').textContent.trim();

            /* Additional Options popup selectors */
            this.additionalOptionsPopupContainer = this.querySelector('#swymcs-additional-options-popup-container');
            this.additionalOptionsPopupCloseButton = this.querySelector('#swymcs-close-additional-popup');
            this.additionalPopupCancelButtons = this.querySelectorAll('.swymcs-additonal-popup-cancel-button');

            /* Share List popup selectors */
            this.shareListPopup = this.querySelector('#swymcs-share-list-popup');
            this.shareLinkField = this.querySelector('#swymcs-share-link-field');
            this.shareNameField = this.querySelector('#swymcs-share-name-field');
            this.shareEmailField = this.querySelector('#swymcs-share-email-field');
            this.shareMessageField = this.querySelector('#swymcs-share-message-field');
            this.shareListError = this.querySelector('#swymcs-share-email-field-error');
            this.emailShareButton = this.querySelector('#swymcs-confirm-share-list');
            this.shareListPopupTitle = this.shareListPopup.querySelector('.swymcs-confirm-share-title');
            this.shareListPopupSenderNameLabel = this.shareListPopup.querySelector('[for="swymcs-share-name-field"]');
            this.shareListPopupSenderEmailLabel = this.shareListPopup.querySelector('[for="swymcs-share-email-field"]');
            this.shareListPopupSenderNotesLabel = this.shareListPopup.querySelector('[for="swymcs-share-message-field"]');

            /* Delete List popup selectors */
            this.deleteListPopup = this.querySelector('#swymcs-delete-list-popup');
            this.deleteListPopupContent = this.deleteListPopup.querySelector('.swymcs-popup-text.swymcs-popup-content');
            this.deleteListPopupTitleText = this.deleteListPopup.querySelector('.swymcs-confirm-delete-title');
            this.confirmDeleteListButton = this.querySelector('#swymcs-confirm-delete-list');
            this.deleteListPopupCancelBtn = this.querySelector('#swymcs-cancel-delete-list');

            this.pageLoader = this.querySelector('#swymcs-loader-container');
            this.wishlistSectionContainer = this.querySelector('.swymcs-wishlist-section-container');
            /* Wishlist Selectors for Strings */

            this.emptyListTitle = this.emptyListContainer.querySelector('#swym-empty-wishlist-container-title');
            this.emptyListDescription = this.emptyListContainer.querySelector('#swym-empty-wishlist-container-description');
            this.emptyListButton = this.emptyListContainer.querySelector('#swym-custom-continue-shopping');

            if (!window.isCustomer) {
                this.guestMessageButton = this.querySelector('#swymcs-guest-user-btn');
            }
        }

        _attachEventListeners() {

            this.body.addEventListener('click', evt => this._overlayEvent(evt));
            this.addEventListener('swym:product-grid-loaded', this._updateLocaleStrings.bind(this));

            /* Adding events to page header elements */

            this.accountButton.addEventListener('click', evt => this._showPopupContainer(this.accountPopup));
            this.accountPopupCloseButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupCancelButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupActionButton.addEventListener('click', this._loginButtonAction.bind(this));

            this.shareListAccountPopupActionButton.addEventListener('click', this._loginButtonAction.bind(this));
            this.shareListAccountPopupCloseButton.addEventListener('click', evt => this._hidePopupContainer(this.shareListAccountPopup));
            this.shareListAccountPopupCancelButton.addEventListener('click', evt => this._hidePopupContainer(this.shareListAccountPopup));

            /* Additional Options Events */
            this.additionalOptionsBtn.addEventListener('click', evt => this._showPopupContainer(this.additionalOptionsContainer));
            this.additionalOptionsContainer.addEventListener('click', this._renderAdditionalOptionsPopup);
            this.shareListButton.addEventListener('click', this._renderShareListPopup.bind(this));

            /* Additional Options Popup Events */
            this.additionalPopupCancelButtons.forEach(btn => btn.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this)));
            this.additionalOptionsPopupCloseButton.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this));

            /* Share List Events */
            this.emailShareButton.addEventListener('click', this._shareListByEmail.bind(this));
            this.shareEmailField.addEventListener('input', this._validateEmail.bind(this));

            /* Delete List Events */
            this.confirmDeleteListButton.addEventListener('click', this._deleteList.bind(this));

            /* Lists grid buttons */
            this.productsContainer.addEventListener('click', this._eventsForProductsGrid);
            if (!window.isCustomer) {
                this.guestMessageButton.addEventListener('click', evt => this._showPopupContainer(this.accountPopup));
            }
        }

        _updateLocaleStrings() {
            const swat = this.swat;
            const loggedInAccountPopupText = swat.retailerSettings.Strings.SaveListPopupLoggedInText.replace(/{{{?email}?}}/g, window.customerEmail);
            const shareListNotesLabel = swat.retailerSettings.Strings.ShareWishlistPopupNoteDefault.replace(/{{{?wishlistName}?}}/g, swat.retailerSettings.Strings.SingleWishlistTitle);
            this.ShareWishlistEmailSuccess = swat.retailerSettings.Strings.ShareWishlistEmailSuccess.replace(/{{{?wishlistName}?}}/g, swat.retailerSettings.Strings.SingleWishlistTitle);

            /* MENU CONTAINER BUTTONS */
            this.accountButtonText.textContent = window.isCustomer ? window.customerEmail : swat.retailerSettings.Strings.GuestShopperTitle;
            this.deleteListButtonText.textContent = swat.retailerSettings.Strings.WishlistContextMenuClearList;
            this.accountPopupTitleText.textContent = swat.retailerSettings.Strings.SaveListPopupSummaryHeading;
            this.singleWishlistTitleText.textContent = swat.retailerSettings.Strings.SingleWishlistTitle;

            /* NOT LOGGED IN CUSTOMER - ACCOUNT POPUP CONTAINER */
            this.accountPopupActionButton.textContent = window.isCustomer ? swat.retailerSettings.Strings.SaveListPopupLoggedInCTASave : swat.retailerSettings.Strings.SaveListPopupSummaryCTALogin;
            this.accountPopupContentText1.innerHTML = window.isCustomer ? loggedInAccountPopupText : swat.retailerSettings.Strings.SaveListPopupSummaryText;
            this.accountPopupCancelButton.textContent = swat.retailerSettings.Strings.SaveListPopupLoggedInCTACancel;

            /* DELETE LIST POPUP CONTAINER */
            this.deleteListPopupTitleText.textContent = swat.retailerSettings.Strings.ClearWishlistPopupHeading;
            this.confirmDeleteListButton.textContent = swat.retailerSettings.Strings.ClearWishlistPopupCTAClear;
            this.deleteListPopupCancelBtn.textContent = swat.retailerSettings.Strings.ClearWishlistPopupCTACancel;

            /* NOT LOGGED IN CUSTOMER - SHARE LIST POPUP CONTAINER */
            this.shareListAccountPopupTitleText.textContent = swat.retailerSettings.Strings.ShareWishlistLoginPopupHeading;
            this.shareListAccountPopupActionButton.textContent = swat.retailerSettings.Strings.SharedWishlistLoginCTA;
            this.shareListAccountPopupContentText1.textContent = swat.retailerSettings.Strings.ShareWishlistLoginPopupText;
            this.shareListAccountPopupContentText2.textContent = swat.retailerSettings.Strings.ShareWishlistLoginPopupMessage;

            /* SHARE LIST POPUP CONTAINER */
            this.shareListPopupTitle.textContent = swat.retailerSettings.Strings.ShareWishlistPopupHeading;
            this.shareListPopupSenderNameLabel.textContent = swat.retailerSettings.Strings.ShareWishlistSenderName;
            this.shareNameField.placeholder = swat.retailerSettings.Strings.ShareWishlistNamePlaceholder;
            this.shareListPopupSenderEmailLabel.textContent = swat.retailerSettings.Strings.ShareWishlistRecipientsEmail;
            this.shareEmailField.placeholder = swat.retailerSettings.Strings.ShareWishlistEmailPlaceholder;
            this.shareListPopupSenderNotesLabel.textContent = swat.retailerSettings.Strings.ShareWishlistMessage;
            this.shareMessageField.placeholder = swat.retailerSettings.Strings.ShareWishlistNotePlaceholder;
            this.shareMessageField.value = shareListNotesLabel;
            this.emailShareButton.textContent = swat.retailerSettings.Strings.ShareWishlistEmailCTA;

            /* EMPTY LIST CONTAINER */
            this.emptyListTitle.textContent = swat.retailerSettings.Strings.EmptyWishlistsHeading;
            this.emptyListDescription.textContent = swat.retailerSettings.Strings.EmptyWishlistsText;
            this.emptyListButton.textContent = swat.retailerSettings.Strings.EmptyWishlistsCTA;

            this._hideContainer(this.pageLoader);
            this._showContainer(this.wishlistSectionContainer);
        }

        async _renderWishlist() {
            this.lists = await this._getLists();
            this.lists.length ? await this._renderSingleWishlist() : this._renderEmptyState();
        }
        
        async _renderShareWishlist() {
            const params = new URL(document.location).searchParams;
            const lid = params.get("lid");
            if (!lid) {
                this._renderProductsGrid([]);
                this._hideContainer(this.wishlistHeader);
                this._showContainer(this.wishlistContainer);
                this._showContainer(this.listProductsContainer);
                return;
            }
            const wishlistProducts = await this._getProductsFromList(lid);
            const shopifyProductsData = await this._getShopifyProductsData(wishlistProducts);
            await this._renderSharedListHeader(lid);
            this._renderProductsGrid(shopifyProductsData);
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
        }

        async _renderSingleWishlist() {
            window.currentActiveListId = this.lists[0]?.lid;
            this.wishlistProducts = await this._getProductsFromList(window.currentActiveListId);
            
            if (!this.wishlistProducts.length) {
                this._renderEmptyState();
                return;
            }
    
            const shopifyProductsData = await this._getShopifyProductsData(this.wishlistProducts);
            await this._renderSingleListHeader(window.currentActiveListId);
            this._renderProductsGrid(shopifyProductsData);
            
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
            this._showContainer(this.additionalOptionsMenuContainer);
        }
    

        _renderEmptyState() {
            this._hideContainer(this.additionalOptionsMenuContainer);
            this._showContainer(this.emptyListContainer);
            this._hideContainer(this.wishlistContainer);
            this.dispatchEvent(new CustomEvent('swym:product-grid-loaded'));
        }

        async _renderSharedListHeader(lid) {
            this._hideContainer(this.additionalOptionsBtn);
            this._hideContainer(this.shareListButton);
        }

        async _renderSingleListHeader(lid) {
            this._showContainer(this.additionalOptionsBtn);
            this._showContainer(this.shareListButton);
        }

        _renderProductsGrid(products) {
            if (!products.length) {
                this._renderEmptyState();
                return;
            }
            let productMarkup = ``;

            // Text for Add to Cart Button
            const shopifyLocale = Shopify.locale;
            const relatedStrings = _swat.retailerSettings.Strings[shopifyLocale] ? _swat.retailerSettings.Strings[shopifyLocale] : _swat.retailerSettings.Strings["en"];
            const addToCartText = relatedStrings.AddToCartCTACanAdd ? relatedStrings.AddToCartCTACanAdd  : "Add to Cart";
            const addedToCartText = relatedStrings.AddToCartCTAAlreadyAdded ? relatedStrings.AddToCartCTAAlreadyAdded : "Added to Cart";
            const soldOutText = relatedStrings.AddToCartCTACannotAdd ? relatedStrings.AddToCartCTACannotAdd : "Sold Out";
            const shopifyRoute = Shopify.routes.root.split('/')[1];

            let primaryDomain;
            if(shopifyRoute == '') {
                 primaryDomain = "https://" + _swat.getPrimaryDomain()  + shopifyRoute + '/';
            } else {
                 primaryDomain = "https://" + _swat.getPrimaryDomain() + "/" + shopifyRoute + '/';
            }
            
        
            products.forEach(async (pdp, index) => {
                if (!pdp) return;
                const product = pdp.productData;
                const selectedVariant = product.variants.find(variant => variant.id === pdp.epi);
                const selectedVariantTitle = selectedVariant.title && selectedVariant.title.toLowerCase() != 'default title' ? ` / ${selectedVariant.title}` : '';
                const selectedVariantPrice = `${this.shoppingCurrencySymbol}${(product.price / 100).toFixed(2)}`;
                
                let addToCartBtnText = selectedVariant.available
                    ? (_swat.platform.isInDeviceCart(selectedVariant.id) ? addedToCartText : addToCartText)
                    : soldOutText;
        
                // Add classes and disable button if sold out
                const inCart = _swat.platform.isInDeviceCart(selectedVariant.id) ? 'swymcs-product-in-cart' : '';
                const isButtonDisabled = !selectedVariant.available ? 'disabled' : '';
        
                // Product images
                const imageSrc = product.images[0] ? product.images[0] : pdp.iu;
                const imageSrc2 = product.images[1] ? product.images[1] : product.images[0];
                const productUrl = primaryDomain + "products" + pdp.productData.productUrl.split('/products')[1];
        
                productMarkup += `
                    <li class="column">
                        <product-card class="product-card text-left product-card--content-spacing-false product-card--border-false has-shadow--false">
                            <figure class="product-featured-image thb-hover">
                            <span class="swym-delete-btn" data-empi="${product.id}" data-epi="${selectedVariant.id}" data-du="${productUrl}">&times;</span>
                                <a href="${productUrl}" title="${selectedVariantTitle}" class="product-featured-image-link aspect-ratio aspect-ratio--portrait" style="--padding-bottom: 125.0%;">
                                    <img class="product-secondary-image lazyautosizes lazyloaded" width="1800" height="2000" data-sizes="auto" src="${imageSrc2}">
                                    <noscript>
                                        <img width="1800" height="2000" sizes="auto" src="${imageSrc2}"/>
                                    </noscript>
                                    <img class="product-primary-image" width="1800" height="2000" data-sizes="auto" src="${imageSrc}">
                                    <noscript>
                                        <img width="1800" height="2000" sizes="auto" src="${imageSrc2}"/>
                                    </noscript>
                                </a>
                            </figure>
                            <div class="product-card-info-outer">
                                <div class="product-card-info">
                                    <a href="${productUrl}" title="${product.title} ${selectedVariantTitle}" class="product-card-title"><h2>${product.title} ${selectedVariantTitle}</h2></a>
                                    <span class="price">
                                        <ins>
                                            <span class="amount">${selectedVariantPrice}</span>
                                        </ins>
                                    </span>
                                </div>
                            </div>
                            <button class="single-add-to-cart-button button accent ${inCart}" ${isButtonDisabled} 
                                data-empi="${product.id}" data-epi="${selectedVariant.id}" data-du="${productUrl}" data-qty="1">
                                ${addToCartBtnText}
                            </button>
                        </product-card>
                    </li>
                `;
            });
        
            this.productsContainer.innerHTML = productMarkup;
            this.productsContainer.classList.remove('swymcs-empty-list');
            this._scrollToTop();
            this.dispatchEvent(new CustomEvent('swym:product-grid-loaded'));
        
            // Attach event listeners to each Add to Cart button
            this.productsContainer.querySelectorAll('.single-add-to-cart-button').forEach(button => {
                button.addEventListener('click', (event) => {
                    const button = event.target;
                    const originalText = button.textContent;
                    button.textContent = 'Adding...'
                    event.preventDefault();
                    const empi = event.currentTarget.getAttribute('data-empi');
                    const epi = event.currentTarget.getAttribute('data-epi');
                    const du = event.currentTarget.getAttribute('data-du');
                    const qty = parseInt(event.currentTarget.getAttribute('data-qty'));
        
                    _swat.replayAddToCart(
                        { empi: empi, du: du, qty: qty }, epi,
                        (success) => {
                            button.textContent = `${addedToCartText}`;
                            const variant = JSON.parse(success).items[0];
                            const productTitle = variant.title;
                            const successMessage = `<strong>${productTitle}</strong> has been added to cart!`;
                            // _swat.ui.showSuccessNotification({ message: successMessage });
                            fetchCartItems();
                        },
                        (error) => {
                            _swat.ui.showErrorNotification({ message: error.description });
                            button.textContent = originalText;
                        }
                    );
                });
            });

            this.productsContainer.querySelectorAll('.swym-delete-btn').forEach((button) => {
                button.addEventListener('click', (event) => {

                    const { empi, epi, du } = event.currentTarget.dataset;
                    const product = { epi, empi, du };

                    event.target.closest('.column').remove();

                     // Update wishlistProducts and render empty state if no products remain
                    this.wishlistProducts = this.wishlistProducts.filter(p => p.epi !== epi);
                        if (!this.wishlistProducts.length) {
                            this._renderEmptyState();
                        }

                    _swat.deleteFromList(
                        currentActiveListId,
                        product,
                        (deletedProduct) => {
                            _swat.fetch((data) => {
                                if(data.length == 0) {
                                    this._renderEmptyState();
                                }
                            })
                        },
                        (error) => console.log("Error while deleting the Product", error)
                    );
                });
            });
        }

        _renderEmptyState() {
            this._hideContainer(this.additionalOptionsMenuContainer);
            this._showContainer(this.emptyListContainer);
            this._hideContainer(this.wishlistContainer);
            this.dispatchEvent(new CustomEvent('swym:product-grid-loaded'));
        }

        async _renderShareListPopup(evt) {
            this._closeAdditionalOptionsPopup();
            this._renderShareList();
        }

        async _renderAdditionalOptionsPopup(evt) {
            const page = document.querySelector('swym-wishlist-page');
            const target = evt.target;
            if (target.id == 'swymcs-additional-options') return;
            page._hidePopupContainer(page.querySelector('.swym-active-popup'));
            const action = target.dataset.action;
            page._closeAdditionalOptionsPopup();
            if (action == 'share') page._renderShareList();
            else if (action == 'delete') page._renderDeleteList();
        }

        _closeAdditionalOptionsPopup() {
            this._hideContainer(this.shareListPopup);
            this._hideContainer(this.deleteListPopup);
            this._hidePopupContainer(this.additionalOptionsPopupContainer);
        }

        async _renderShareList() {
            if (!window.isCustomer) {
                this._showPopupContainer(this.shareListAccountPopup);
                return;
            }
            // const list = await this._markListAsPublic();
            const shareableLink = await this._prepareShareLink();
            this.shareLinkField.textContent = shareableLink;
            this._showContainer(this.shareListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDeleteList() {
            this.deleteListString = _swat.retailerSettings.Strings.ClearWishlistPopupConfirmMessage.replace(/{{{?listName}?}}/g, `<span class="swymcs-highlighted-popup-text" id="swymcs-confirm-delete-list-name">${this.swat.retailerSettings.Strings.SingleWishlistTitle}</span>`);
            this.deleteListPopupContent.innerHTML = this.deleteListString;
            this._showContainer(this.deleteListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        /* Show / Hide containers */

        _overlayEvent(evt) {
            if (evt.target.nodeName == 'BODY') {
                this.querySelectorAll(".swym-active-popup").forEach(popup => this._hidePopupContainer(popup));
            }
        }

        _scrollToTop() {
            const header = document.querySelector('.swymcs-page-header');
            if (header) {
                var targetOffsetTop = header.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: targetOffsetTop,
                    behavior: "smooth"
                });
            }
        }

        _showPopupContainer(selector) {
            selector.classList.remove('swym-hide-container');
            selector.classList.add('swym-active-popup');
            this.body.classList.add('no-scroll');
        }

        _hidePopupContainer(selector) {
            selector.classList.add('swym-hide-container');
            selector.classList.remove('swym-active-popup');
            this.body.classList.remove('no-scroll');
        }

        _showContainer(selector) {
            selector.classList.remove('swym-hide-container');
        }

        _hideContainer(selector) {
            selector.classList.add('swym-hide-container');
        }

        /* Javascript APIs related functions */
        _getLists() {
            return new Promise(async (resolve, reject) => {
                this.swat.fetchLists({
                    callbackFn: lists => resolve(lists),
                    errorFn: err => reject(err)
                });
            });
        }

        _getListDetails(lid) {
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListDetails(
                    { lid: lid },
                    list => resolve(list),
                    error => reject(error)
                );
            });
        }

        _getProductsFromList(lid) {
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListCtx(
                    { lid: lid },
                    listContents => resolve(listContents),
                    error => reject(error)
                );
            });
        }

        async _getShopifyProductsData(products) {
            const section = this;
            if (!products.length) return [];
            let buggedProductsArray = [];
            let response = await Promise.all(products.map(async (product) => {
                try {
                    const [storeUrlString, productHandleString] = product.du.split('/products/');
                    const productHandle = productHandleString.split('?')[0];
                    let primaryDomain = "https://" + _swat.getPrimaryDomain();
                    const reqURL = `${primaryDomain}${Shopify.routes.root}products/${productHandle}`;
                    const jsonData = await JSON.parse(await section._fetchTranslatedProductData(reqURL));
                    jsonData.productUrl = `${storeUrlString}${Shopify.routes.root}products/${jsonData.handle}?variant=${product.epi}`;
                    product.productData = jsonData;
                    return product;
                }
                catch (error) {
                    const errorObj = {};
                    errorObj[product.du] = error;
                    buggedProductsArray.push(errorObj);
                    return null;
                }
            }));
            response = response.filter(product => product && product.productData);
            return response;
        }

        async _fetchTranslatedProductData(url) {
            const sectionHtml = await (await fetch(`${url}?section_id=swym-translated-product-data`)).text();
            const productDataHTML = new DOMParser().parseFromString(sectionHtml, "text/html").getElementById("swym-translated-product-data").textContent;
            return productDataHTML;
        }

        _deleteProductFromList(product, lid, parentNode) {
            const onSuccess = async deletedProduct => {
                parentNode.remove();
                if (!this.productsContainer.querySelector('.swymcs-product-card')) {
                    this._renderProductsGrid([]);
                }
                this.lists = await this._getLists();
            }
            const onError = error => console.log("Error while deleting the Product", error)
            this.swat.deleteFromList(lid, product, onSuccess, onError);
        }

        _deleteList() {
            const onSuccess = deletedListObj => {
                this._closeAdditionalOptionsPopup();
                this._renderWishlist(_swat);
            }
            const onError = error => console.log(`Error while deleting the List, ${lid}`, error);
            _swat.deleteList(window.currentActiveListId, onSuccess, onError);
        }

        _validateListName(name, errorField) {
            const isValidList = false;
            if (name.length < 3) {
                errorField.textContent = 'Name must be longer than 3 characters';
                return isValidList;
            }
            const lists = this.lists;
            const matchedList = lists.find(list => list.lname.trim().toLowerCase() == name);
            if (matchedList) {
                errorField.textContent = 'List name already exists';
                return isValidList;
            }
            errorField.textContent = '';
            return !isValidList;
        }

        _validateEmail() {
            const emailPattern = /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/;
            const isBlank = this.shareEmailField.value == '' ? true : false;
            const isInvalidString = !this.shareEmailField.value.match(emailPattern) ? true : false;
            if (isBlank || isInvalidString) {
                // this.shareListError.textContent = isBlank ? 'Please enter the email address' : 'Please enter a valid email address';
                this.shareListError.textContent = this.swat.retailerSettings.Strings.ValidationErrorEmail;
                return false;
            }
            this.shareListError.textContent = '';
            return true;
        }

        _markListAsPublic() {
            return new Promise(async (resolve, reject) => {
                this.swat.markListPublic(window.currentActiveListId,
                    list => resolve(list),
                    err => reject(err)
                );
            });
        }

        _prepareShareLink() {
            return new Promise(async (resolve, reject) => {
                this.swat.generateSharedListURL(window.currentActiveListId,
                    (link, lid) => resolve(link, lid),
                    err => reject(err)
                );
            });
        }

        _shareListByEmail() {
            const email = this._validateEmail();
            if (!email) return;
            const onSuccess = response => {
                const imageUrl = response.listinfo.listcontents[0]?.iu || response.listinfo.listContents[1]?.iu;
                const html = `
                    <style>
                        .swym-notification-success-inner .swym-image{ display: none !important }
                        #swym-custom-notification-content { display: flex; gap: 10px; align-items: center; cursor: pointer }
                        #swym-custom-notification-content #swym-custom-image-container { position: relative; min-height: 96px; min-width: 96px; max-height: 96px; max-width: 96px; background-color: #F5F5F5 }
                        #swym-custom-notification-content #swym-custom-image-container #swym-custom-image { width: 100%; height: 100%; object-fit: cover; mix-blend-mode: multiply !important }
                        #swym-custom-notification-content #swym-custom-title-container { font-weight: 500; font-size: 14px }
                        .swym-notification-success-inner, .swym-notification-success-inner .swym-details-container .swym-details { padding: 0 !important }
                    </style>
                    <div id="swym-custom-notification-content">
                        <div id="swym-custom-image-container">
                            <img id="swym-custom-image" src="${imageUrl}" alt="wishlisted product image"/>
                        </div>
                        <div id="swym-custom-title-conatainer">${this.ShareWishlistEmailSuccess}</div>
                    </div>
                `;
                _swat.ui.uiRef.showSuccessNotification({ message: `${html}` });
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => _swat.ui.uiRef.showErrorNotification({ message: this.swat.retailerSettings.Strings.ShareWishlistEmailError });
            _swat.sendListViaEmail({
                'toEmailId': this.shareEmailField.value.trim(),
                'note': this.shareMessageField.value,
                'fromName': this.shareNameField.value,
                'lid': window.currentActiveListId,
            }, onSuccess, onError);
        }

        /* Header functions */

        _loginButtonAction(evt) {
            const redirectionUrl = evt.currentTarget.getAttribute('data-redirection-url');
            const actionUrl = evt.currentTarget.getAttribute('data-action-url');
            localStorage.setItem('SWYM_REDIRECT_URL', redirectionUrl);
            localStorage.setItem('SWYM_ACTION_URL', actionUrl);
            location.href = actionUrl;
        }

        /* Product Grid Events */

        async _eventsForProductsGrid(evt) {
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            const purpose = target.dataset?.purpose;
            if (!purpose) return;
            evt.preventDefault();
            if (purpose == 'delete') {
                page._deleteProductFromList(
                    {
                        "epi": target.dataset.epi,
                        "empi": target.dataset.empi,
                        "du": target.dataset.du
                    }, target.dataset.lid, target.closest('.swymcs-product-card')
                );
            }
        }
    }
    customElements.define('swym-wishlist-page', SwymWishlistPage);
}